import { useEffect, useRef } from "react"
import { useFormContext, useWatch } from "react-hook-form"
import { SearchMultiSelectDropdown } from "./SearchMultiSelectDropdown"
import { EpisodeItemList } from "./EpisodeItemList"
import { useEpisodesSearch } from "hooks/episode"
import { useShowsSearch } from "hooks/shows-master"
import { useCollectionSearch } from "hooks/collection"

type Props = {
  initialData?: any[]
  onEpisodesChange?: (episodes: any[]) => void
}

export function EpisodeForm({ initialData, onEpisodesChange }: Props) {
  const { control, setValue } = useFormContext()

  /* ---------- Stable watch ---------- */
  const episodes = useWatch({
    control,
    name: "entities",
    defaultValue: []
  })

  /* ---------- Prefill ONLY ONCE ---------- */
  const initializedRef = useRef(false)

  useEffect(() => {
    if (
      !initializedRef.current &&
      Array.isArray(initialData) &&
      initialData.length
    ) {
      setValue("entities", initialData, { shouldDirty: false })
      initializedRef.current = true
    }
  }, [initialData, setValue])

  /* ---------- Optimized change detection ---------- */
  const prevIdsRef = useRef<number[]>([])

  useEffect(() => {
    if (!onEpisodesChange) return

    const ids = episodes.map((e: any) => e?.id)

    // FAST shallow compare (no stringify)
    if (
      ids.length !== prevIdsRef.current.length ||
      ids.some((id, i) => id !== prevIdsRef.current[i])
    ) {
      prevIdsRef.current = ids
      onEpisodesChange(episodes)
    }
  }, [episodes, onEpisodesChange])

  return (
    <div className="space-y-3">
      <SearchMultiSelectDropdown placeholder='Search Collections' label="Select Collections" name="collection" useSearchHook={useCollectionSearch} />
       <SearchMultiSelectDropdown placeholder='Search Shows' label="Select Shows" name="show" useSearchHook={useShowsSearch} />
      <SearchMultiSelectDropdown placeholder='Search Episodes' label="Select Episodes" name="episode" useSearchHook={useEpisodesSearch} />
      <EpisodeItemList />
    </div>
  )
}
